import React from 'react';
import DescriptionsFormItem from '@mpc/common/src/components/DescriptionsFormItem';
import { ContractMethodTag } from '@mpc/common/src/features/MPCDemand/enum';
import CopyableNode from "@mpc/common/src/components/CopyableNode";

interface Props {
  detail?: any
}

const ContractInformation = ({
  detail,
}: Props) => {
  return (
    <div className='m-b-12'>
      <DescriptionsFormItem
        items={
          [
            {
              view: true,
              formItemKey: 'demand_suppliers[0].contract_method',
              label: '是否使用合同',
              span: 1,
              show: () => true,
              elementProps: () => {
                return {
                  showComponent: () => {
                    const value = detail?.demand_suppliers?.[0]?.contract_method;
                    const no_contract_flag = detail?.demand_suppliers?.[0]?.no_contract_flag
                    if (value === undefined && no_contract_flag !== undefined) {
                      return <ContractMethodTag value={no_contract_flag ? 'NO_NEED' : 'REUSE'} />;
                    }
                    return <ContractMethodTag value={value} />;
                  },
                };
              },
            },
            {
              formItemKey: 'demand_suppliers[0]?.contract_no',
              label: '合同编号',
              span: 1,
              view: true,
              show: () => {
                    const value = detail?.demand_suppliers?.[0]?.contract_method;
                    const no_contract_flag = detail?.demand_suppliers?.[0]?.no_contract_flag
                    if (value === undefined && no_contract_flag !== undefined) {
                      return !no_contract_flag;
                    }
                    return value !== 'NO_NEED';
              },
              elementProps: () => {
                return {
                  showComponent: () => {
                    const value = detail?.demand_suppliers?.[0]?.contract_no;
                    return value ? <CopyableNode value={value} tipToolTitle="复制" >
                      {value}
                    </CopyableNode> : '--'
                  },
                };
              },
            },
          ].filter(item => item.show?.())
        }
      >
      </DescriptionsFormItem >
    </div>
  )
}

export default ContractInformation;
